import { render, staticRenderFns } from "./manage2.vue?vue&type=template&id=81d49faa&scoped=true"
import script from "./manage2.vue?vue&type=script&lang=js"
export * from "./manage2.vue?vue&type=script&lang=js"
import style0 from "./manage2.vue?vue&type=style&index=0&id=81d49faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d49faa",
  null
  
)

export default component.exports